function showTab(tabId) {
    var tabContents = document.querySelectorAll('.tab-content');
    tabContents.forEach(function(content) {
        content.classList.remove('active');
    });

    var tabItems = document.querySelectorAll('.tab__menu-item');
    tabItems.forEach(function(item) {
        item.classList.remove('tab__menu-item-active');
    });

    document.getElementById(tabId).classList.add('active');
    document.querySelector('[href="#' + tabId + '"]').parentNode.classList.add('tab__menu-item-active');

}

function handleHashChange() {
    var hash = window.location.hash;
    if (hash) {
        var tabId = hash.substring(1);
        showTab(tabId);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    handleHashChange();
});

window.onhashchange = handleHashChange;

document.querySelectorAll('.tab__menu-item').forEach(function(item) {
    item.addEventListener('click', function(event) {
        var tabId = this.querySelector('a').getAttribute('href').substring(1);
        showTab(tabId);
        event.preventDefault();
    });
});

document.addEventListener('DOMContentLoaded', function() {
    handleHashChange();
});
